import { TransactionEventTypeMock } from '../types/client.enum';
import { TransactionModelMock } from '../types/client.interfaces';
import { TransactionDetailDisplayFormat } from '../types/client.types';

export const formattingTransactionDetail = (transactions: TransactionModelMock[]) => {
  const transactionDetailFormat: TransactionDetailDisplayFormat[] = [];
  const interestTransactions = transactions.filter(
    (transaction) => transaction.transactionEventType === TransactionEventTypeMock.interest
  );

  if (interestTransactions.length > 0) {
    const totalSourceAmount = interestTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountSource ? transaction.amountSource : 0;
      return acc + amount;
    }, 0);
    const totalTargetAmount = interestTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountTarget ? transaction.amountTarget : 0;
      return acc + amount;
    }, 0);
    transactionDetailFormat.push({
      title: 'Interest',
      amountDescription: 'Amount',
      totalSourceAmount: totalSourceAmount,
      totalTargetAmount: totalTargetAmount,
      shouldHaveBorder: true,
      transactions: interestTransactions
    });
  }

  const dividendDeclarationTransactions = transactions.filter(
    (transaction) =>
      transaction.transactionEventType === TransactionEventTypeMock.dividendDeclaration
  );

  if (dividendDeclarationTransactions.length > 0) {
    const totalSourceAmount = dividendDeclarationTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountSource ? transaction.amountSource : 0;
      return acc + amount;
    }, 0);
    const totalTargetAmount = dividendDeclarationTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountTarget ? transaction.amountTarget : 0;
      return acc + amount;
    }, 0);
    transactionDetailFormat.push({
      title: 'Dividend declaration',
      amountDescription: 'Amount',
      totalSourceAmount: totalSourceAmount,
      totalTargetAmount: totalTargetAmount,
      shouldHaveBorder: true,
      transactions: dividendDeclarationTransactions
    });
  }

  const interestDeclarationTransactions = transactions.filter(
    (transaction) =>
      transaction.transactionEventType === TransactionEventTypeMock.interestDeclaration
  );

  if (interestDeclarationTransactions.length > 0) {
    const totalSourceAmount = interestDeclarationTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountSource ? transaction.amountSource : 0;
      return acc + amount;
    }, 0);
    const totalTargetAmount = interestDeclarationTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountTarget ? transaction.amountTarget : 0;
      return acc + amount;
    }, 0);
    transactionDetailFormat.push({
      title: 'Interest declaration',
      amountDescription: 'Amount',
      totalSourceAmount: totalSourceAmount,
      totalTargetAmount: totalTargetAmount,
      shouldHaveBorder: true,
      transactions: interestDeclarationTransactions
    });
  }

  const feesTransactions = transactions.filter(
    (transaction) => transaction.transactionEventType === TransactionEventTypeMock.fees
  );

  if (feesTransactions.length > 0) {
    const totalSourceAmount = feesTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountSource ? transaction.amountSource : 0;
      return acc + amount;
    }, 0);
    const totalTargetAmount = feesTransactions.reduce((acc, transaction) => {
      const amount = transaction.amountTarget ? transaction.amountTarget : 0;
      return acc + amount;
    }, 0);
    transactionDetailFormat.push({
      title: 'Fees',
      amountDescription: 'Amount',
      totalSourceAmount: totalSourceAmount,
      totalTargetAmount: totalTargetAmount,
      shouldHaveBorder: true,
      transactions: interestDeclarationTransactions
    });
  }

  return transactionDetailFormat;
};
